'use client'

import { Outlet } from 'react-router-dom'
import MUIStack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { AuthScreenFooter } from '@repo/ui/AuthScreenFooter'
import { useWordpressStore } from '@repo/store/useWordpressStore'
import { useEffect } from 'react'
import * as styles from './AuthLayout.module.scss'

export const AuthLayout = () => {
  const theme = useTheme()
  const { fetchLoginPromo, loginPromo } = useWordpressStore()

  useEffect(() => {
    fetchLoginPromo()
  }, [fetchLoginPromo])

  return (
    <MUIStack
      justifyContent="center"
      alignItems="flex-start"
      direction="row"
      sx={{
        width: '100%',
        height: '100%',
        background: 'white'
      }}
    >
      <MUIStack
        justifyContent="center"
        alignItems="flex-start"
        className={styles.loginForm}
        sx={{
          height: '100%',
          background: 'white'
        }}
      >
        <MUIStack
          justifyContent="center"
          alignItems="flex-start"
          sx={{
            padding: '60px',
            width: '100%',
            height: '100%',
            minHeight: '645px'
          }}
        >
          <div style={{ minHeight: '460px', width: '100%' }}>
            <Outlet />
          </div>
        </MUIStack>

        <AuthScreenFooter />
      </MUIStack>

      <iframe
        className={styles.loginPromoIframe}
        srcDoc={loginPromo || ''}
        width="100%"
        height="100%"
        style={{ border: 'none', background: theme.palette.secondary.main, overflow: 'hidden' }}
      />
    </MUIStack>
  )
}
